import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle2, Loader2, XCircle, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { API } from '../lib/api';

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get('session_id');
  const [status, setStatus] = useState('checking'); // checking | paid | pending | error
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setStatus('error'); return; }
    let timer;
    const poll = async () => {
      if (attempts.current >= 6) { setStatus('pending'); return; }
      attempts.current += 1;
      try {
        const { data } = await API.get(`/payments/status/${sessionId}`);
        if (data.payment_status === 'paid') { setStatus('paid'); return; }
        timer = setTimeout(poll, 2000);
      } catch { setStatus('error'); }
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div className="luxe-bg flex min-h-screen items-center justify-center px-4">
      <div className="glass w-full max-w-md rounded-3xl p-8 text-center">
        {status === 'checking' && (<><Loader2 className="mx-auto h-10 w-10 animate-spin text-primary" /><h1 className="mt-4 font-display text-xl font-bold text-white">Confirming your payment…</h1></>)}
        {status === 'paid' && (<>
          <div className="mx-auto mb-3 flex h-16 w-16 items-center justify-center rounded-full bg-primary/15"><CheckCircle2 className="h-9 w-9 text-primary" /></div>
          <h1 className="font-display text-2xl font-bold text-white">Payment successful! 🎉</h1>
          <p className="mt-2 text-sm text-white/70">Check your email for access. Thank you for your purchase.</p>
        </>)}
        {status === 'pending' && (<><Loader2 className="mx-auto h-10 w-10 animate-spin text-primary" /><h1 className="mt-4 font-display text-xl font-bold text-white">Still processing</h1><p className="mt-2 text-sm text-white/70">This can take a moment. You'll get an email once it's confirmed.</p></>)}
        {status === 'error' && (<><XCircle className="mx-auto h-10 w-10 text-destructive" /><h1 className="mt-4 font-display text-xl font-bold text-white">Something went wrong</h1></>)}
        <Button onClick={() => navigate('/store')} className="mt-6 w-full rounded-xl bg-primary font-semibold text-primary-foreground hover:bg-primary/90">Back to store <ArrowRight className="ml-1.5 h-4 w-4" /></Button>
      </div>
    </div>
  );
}

export function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="luxe-bg flex min-h-screen items-center justify-center px-4">
      <div className="glass w-full max-w-md rounded-3xl p-8 text-center">
        <XCircle className="mx-auto h-10 w-10 text-white/50" />
        <h1 className="mt-4 font-display text-2xl font-bold text-white">Checkout canceled</h1>
        <p className="mt-2 text-sm text-white/70">No worries — your card was not charged.</p>
        <Button onClick={() => navigate('/store')} className="mt-6 w-full rounded-xl bg-primary font-semibold text-primary-foreground hover:bg-primary/90">Back to store</Button>
      </div>
    </div>
  );
}
